import { combineLatest, Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { AppendState as AppendUserState, UserSession } from '@wearejh/m2-pwa-user';

import { AppendState as AppendCartState, CartVariant } from '../cart.reducer';

export function cartId(state$: Observable<AppendCartState>): Observable<AppendCartState['cart']['cartId']> {
    return state$.pipe(pluck<AppendCartState, 'cart', 'cartId'>('cart', 'cartId'));
}

/**
 * @param state$
 */
export function cartVariantAndId(
    state$: Observable<AppendCartState<AppendUserState>>,
): Observable<[CartVariant, AppendCartState['cart']['cartId']]> {
    const cartVariant$: Observable<CartVariant> = state$.pipe(
        pluck<AppendUserState, 'user', 'session'>('user', 'session'),
        map((s) => (s === UserSession.SignedIn ? CartVariant.Account : CartVariant.Guest)),
    );
    return combineLatest([cartVariant$, cartId(state$)]);
}

export function cartItems(state: Observable<AppendCartState>) {
    return state.pipe(pluck('cart', 'items'));
}
